import { Link, useSearchParams } from 'react-router-dom'

/** URL-backed views use ordinary link semantics, including browser history. */
export function ViewNav({
  items,
  current,
}: {
  items: readonly (readonly [string, string])[]
  current: string
}) {
  const [params] = useSearchParams()
  return (
    <nav className="view-nav" aria-label="Page views">
      {items.map(([value, label]) => {
        const next = new URLSearchParams(params)
        next.set('view', value)
        next.delete('page')
        return (
          <Link key={value} to={`?${next}`} aria-current={current === value ? 'page' : undefined}>
            {label}
          </Link>
        )
      })}
    </nav>
  )
}
